import axios, { AxiosInstance } from 'axios';
import authToken from 'src/services/auth-header';

export const baseURL = process.env.REACT_APP_API_URL

const httpClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const plainHttpClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const attachAuthInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    const token = authToken();
    console.log('Auth token:', token ? 'Present' : 'Missing');
    
    // Ensure headers object exists
    if (!config.headers) {
      config.headers = {};
    }
    
    // Add Authorization header if token exists and not already present
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    console.log('Request config:', {
      url: config.url,
      method: config.method,
      headers: config.headers
    });
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      console.log('Response received:', {
        status: response.status,
        url: response.config.url,
        data: response.data
      });
      return response;
    },
    (error) => {
      console.error('Response error:', {
        status: error.response?.status,
        url: error.config?.url,
        message: error.message,
        data: error.response?.data
      });
      return Promise.reject(error);
    }
  );
};

attachAuthInterceptor(httpClient);
attachAuthInterceptor(plainHttpClient);

export default httpClient;
